module.exports = __webpack_public_path__ + "static/media/three_quarters_left_front_picture.c59cca52.jpg";